export const BROWSER_DEFAULT_FONT_SIZE = 16

function pixelsToRems(pixels: number): string {
  const rems = pixels / BROWSER_DEFAULT_FONT_SIZE

  return `${rems}rem`
}

export default pixelsToRems
